import { api } from "@/lib/api";

export const ARCHETYPE_LABELS = {
  lead_capture: "Lead Capture Form",
  content_pack: "Content Pack",
  brand_kit: "Brand Kit",
  recommender: "Recommender Quiz",
};

export const ARCHETYPE_BLURBS = {
  lead_capture: "A high-converting form that catches qualified leads and routes them to your inbox.",
  content_pack: "A weekly content calendar in your voice, ready to schedule across your channels.",
  brand_kit: "Tone, palette, fonts and taglines, so every asset sounds and looks like you.",
  recommender: "A short quiz that recommends the right product, plan or service for each visitor.",
};

export const ARCHETYPES = ["lead_capture", "content_pack", "brand_kit", "recommender"];

export async function listProjects() {
  const { data } = await api.get("/vault/projects");
  return data;
}

export async function getProject(id) {
  const { data } = await api.get(`/vault/projects/${id}`);
  return data;
}

export async function createProject({ name, archetype, config }) {
  const { data } = await api.post("/vault/projects", { name, archetype, config });
  return data;
}

export async function patchProject(id, payload) {
  const { data } = await api.patch(`/vault/projects/${id}`, payload);
  return data;
}

export async function deleteProject(id) {
  await api.delete(`/vault/projects/${id}`);
}

export async function draftWithBuilder({ archetype, prompt }) {
  const { data } = await api.post("/vault/builder/draft", { archetype, prompt });
  return data;
}
